export default __webpack_public_path__ + "static/media/140.53e21fe9.png";